import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import AddDepartment from "../Registration/Department/addDepartment";
import AltDepartment from "../Registration/Department/altDepartment";
import DelDepartment from "../Registration/Department/delDepartment";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import "./prelude.css";
import BottomBar from "../../Components/bottomBar/bottomBar";
import Api from "../../services/api";
import Alert from "../../Components/alert/Alert";
import { handleColor } from "../../services/Functions";
import ReportDepartaments from "../Reports/reportDepartaments";

class prelude_department extends React.Component {
  render() {
    return (
      <>
        <header>
          <Top_bar />{" "}
        </header>
        <div className="prelude_container">
          <Sidebar></Sidebar>
        </div>
        <BottomBar></BottomBar>
      </>
    );
  }
}

class Sidebar extends React.Component {
  state = { data: [], keys: [], render: false, message: "", click: false };

  async componentWillMount() {
    let array = [];
    await Api.get("/departments")
      .then((response) => {
        response.data.forEach((element) => {
          array.push({
            Código: element.code,
            Departamento: element.description,
          });
        });
        if (array.length > 0) this.setState({ data: array, render: true });
      })
      .catch((err) => {
        this.setState({ message: "" });
      });
    let viewport = document.querySelector("meta[name=viewport]");
    viewport.setAttribute(
      "content",
      viewport.content + ", height=" + window.innerHeight
    );
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const { show, message } = this.state;

    return (
      <Tab.Container defaultActiveKey="list">
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1 ">
            <div className="sidebar2">
              <Col className="sidebarColumn">
                <ListGroup>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg1"
                    onClick={handleColor}
                    className="listGroup"
                    eventKey="list"
                  >
                    Setores
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg2"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="add"
                  >
                    Adicionar Setores
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg3"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="alt"
                  >
                    Alterar Setores
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg4"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="del"
                  >
                    Deletar Setores
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </div>
            <Col
              className="col3"
              style={{
                top: "5%",
                marginLeft: "1.5%",
                height: "78vh",
                width: "100%",
              }}
            >
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              <Tab.Content>
                <Tab.Pane eventKey="list">
                  {this.handleClick ? <ReportDepartaments /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="add">
                  {this.handleClick ? <AddDepartment /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="alt">
                  {this.handleClick ? <AltDepartment /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="del">
                  {this.handleClick ? <DelDepartment /> : null}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default prelude_department;
